import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import { PROOF } from "@/data/content";

// Proof wall: real student screenshots in a masonry layout (never cropped),
// plus one featured student block.
export default function ProofSection() {
  return (
    <section className="bg-ink-950 px-6 py-16 md:py-24" data-testid="proof-section">
      <div className="mx-auto max-w-5xl">
        <SectionHeader
          center
          title={PROOF.headline}
          support={PROOF.support}
          testId="proof-heading"
        />

        <div
          className="mt-10 gap-5 [column-fill:_balance] sm:columns-2 md:columns-3 md:mt-12"
          data-testid="proof-wall"
        >
          {PROOF.items.map((item, i) => (
            <Reveal key={item.src} delay={i * 0.06} className="mb-5 break-inside-avoid">
              <figure
                className="overflow-hidden rounded-lg border border-line bg-ink-900"
                data-testid={`proof-item-${i + 1}`}
              >
                <img src={item.src} alt={item.alt} loading="lazy" className="w-full" />
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-12 md:mt-16">
          <div
            className="mx-auto grid max-w-4xl items-center gap-8 rounded-lg border border-line bg-ink-900/60 p-6 md:grid-cols-[1.05fr_1fr] md:p-8"
            data-testid="featured-testimonial"
          >
            <figure
              className="overflow-hidden rounded-lg border border-line bg-ink-900"
              data-testid="featured-media"
            >
              <img src={PROOF.featured.src} alt={PROOF.featured.alt} loading="lazy" className="w-full" />
            </figure>
            <div className="text-center md:text-left">
              <h3 className="font-display text-xl font-medium text-fg md:text-2xl" data-testid="featured-name">
                {PROOF.featured.name}
              </h3>
              <p
                className="mt-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-light"
                data-testid="featured-result"
              >
                {PROOF.featured.result}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-fg-muted md:text-base" data-testid="featured-text">
                {PROOF.featured.text}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}